import getFormattedDollarPrice from './getters/getFormattedDollarPrice';

export function centsToAmount(cents: number): number {
  if (!Number.isInteger(cents)) {
    throw new TypeError(`Expected an integer amount of cents, received ${cents}`);
  }

  return cents / 100;
}

export function formatCents(cents: number): string {
  return getFormattedDollarPrice(centsToAmount(cents));
}

export function basisPointsToPercentLabel(basisPoints: number): string {
  return String(basisPoints / 100);
}
